import axios from "axios";

// const API = axios.create({ baseURL: 'http://localhost:5000'})
const API = axios.create({ baseURL: process.env.REACT_APP_API });

API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
  }

  return req;
});

// export const fetchInvoices =() => API.get('/invoices')
export const fetchInvoice = (id) => API.get(`/invoices/${id}`);
export const fetchInvoicesByClient = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
}) =>
  API.post(`/invoices/client`, { page, rowsPerPage, id, startDate, endDate });
export const addInvoice = (invoice) => API.post("/invoices", invoice);
export const updateInvoice = (id, updatedInvoice) =>
  API.post(`/invoices/${id}`, updatedInvoice);
export const deleteInvoice = (id) => API.post(`/invoices/delete/${id}`);
export const fetchInvoicesByUser = (searchQuery) =>
  API.get(`/invoices/user?searchQuery=${searchQuery.search}`);
export const fetchInvoices = () => API.get("/invoices");
export const fetchInvoicesCount = () => API.get("/invoices/count");

export const fetchDeletedInvoices = () => API.get("/invoices/deleted"); // Add this
export const softdeleteInvoice = (id) => API.post(`/invoices/softdelete/${id}`);

export const createCashTransaction = (transaction) => API.post("/cash-transactions", transaction);
export const fetchCashTransactions = (startDate, endDate) =>
  API.get(`/cash-transactions?startDate=${startDate}&endDate=${endDate}`);
export const closeRegister = (data) => API.post("/cash-transactions/close", data);
export const fetchCashSummary = (date) => API.get(`/cash-transactions/summary?date=${date}`);
export const generateDailyReport = (date) => API.get(`/cash-transactions/report?date=${date}`);

export const updateStaffCommissionDetail = (id, updatedStaffCommissionDetail) =>
  API.post(`/staffCommissionDetails/update/${id}`, updatedStaffCommissionDetail);
export const fetchStaffCommissionDetail = (id) =>
  API.get(`/staffCommissionDetails/${id}`);
export const addStaffCommissionDetail = (staffCommissionDetail) =>
  API.post("/staffCommissionDetails", staffCommissionDetail);


export const updateStaffCommissionDetails = async (
  updatedStaffCommissionDetails
) => {
  try {
    console.log(
      "Update StaffCommissionDetails from API index: ",
      updatedStaffCommissionDetails
    );
    const response = await API.post(
      `/staffCommissionDetails/update`,
      updatedStaffCommissionDetails
    );

    if (response.status === 200) {
      console.log("staffCommissionDetails updated successfully");
    } else {
      console.error("Failed to update staffCommissionDetails");
    }
  } catch (error) {
    console.error(
      "An error occurred while updating staffCommissionDetails:",
      error
    );
  }
};
export const deleteStaffCommissionDetail = (id) =>
  API.post(`/staffCommissionDetails/delete/${id}`);
export const fetchStaffCommissionDetailsByUser = (searchQuery) =>
  API.get(`/staffCommissionDetails/user?searchQuery=${searchQuery.search}`);
export const fetchStaffCommissionDetails = () =>
  API.get("/staffCommissionDetails");

export const fetchPurchase = (id) => API.get(`/purchases/${id}`);
export const addPurchase = (purchase) => API.post("/purchases", purchase);
export const updatePurchase = (id, updatedPurchase) =>
  API.post(`/purchases/${id}`, updatedPurchase);
export const deletePurchase = (id) => API.post(`/purchases/delete/${id}`);
export const fetchPurchasesByUser = (searchQuery) =>
  API.get(`/purchases/user?searchQuery=${searchQuery.search}`);
export const fetchPurchases = () => API.get("/purchases");

export const fetchMeeting = (id) => API.get(`/meetings/${id}`);
export const addMeeting = (meeting) => API.post("/meetings", meeting);
export const updateMeeting = (id, updatedMeeting) =>
  API.post(`/meetings/${id}`, updatedMeeting);
export const deleteMeeting = (id) => API.post(`/meetings/delete/${id}`);
export const fetchPaymentsByClient = ({
  page,
  rowsPerPage,
  id,
  startDate,
  endDate,
}) =>
  API.post(`/meetings/client`, { page, rowsPerPage, id, startDate, endDate });
export const fetchMeetingsByUser = (searchQuery) =>
  API.get(`/meetings?searchQuery=${searchQuery.search}`);
export const fetchMeetings = () => API.get("/meetings");

export const fetchClient = (id) => API.get(`/clients/${id}`);
export const fetchClients = (page) => API.get(`/clients?page=${page}`);
export const addClient = (client) => API.post("/clients", client);
export const updateClient = (id, updatedClient) =>
  API.post(`/clients/${id}`, updatedClient);
export const deleteClient = (id) => API.post(`/clients/delete/${id}`);
export const fetchClientsByUser = (searchQuery) =>
  API.get(`/clients/user?searchQuery=${searchQuery.search}`);
export const fetchAllClients = () => API.get("/clients");

export const fetchSupplier = (id) => API.get(`/suppliers/${id}`);
export const fetchSuppliers = (page) => API.get(`/suppliers?page=${page}`);
export const addSupplier = (supplier) => API.post("/suppliers", supplier);
export const updateSupplier = (id, updatedSupplier) =>
  API.post(`/suppliers/${id}`, updatedSupplier);
export const deleteSupplier = (id) => API.post(`/suppliers/delete/${id}`);
export const fetchSuppliersByUser = (searchQuery) =>
  API.get(`/suppliers/user?searchQuery=${searchQuery.search}`);
export const fetchAllSuppliers = () => API.get("/suppliers");

// export const adminSignIn =(formData)=> API.post('/users/adminSignin', formData)
export const adminSignUp = (formData) =>
  API.post("/users/adminSignup", formData);
export const signIn = (formData) => API.post("/users/signin", formData);
export const signUp = (formData) => API.post("/users/signup", formData);
export const forgot = (formData) => API.post("/users/forgot", formData);
export const reset = (formData) => API.post("/users/reset", formData);
export const fetchUsers = () => API.get("/users");
export const deleteUser = (id) => API.post(`/users/delete/${id}`);
export const updateUser = (id, updatedUser) =>
  API.post(`/users/${id}`, updatedUser);
export const adminChangePassword = (userId, newPassword) =>
  API.post(`/users/change-password/${userId}`, { newPassword });

export const fetchProfilesBySearch = (searchQuery) =>
  API.get(
    `/profiles/search?searchQuery=${
      searchQuery.search || searchQuery.year || "none"
    }`
  );
export const fetchProfile = (id) => API.get(`/profiles/${id}`);
export const fetchProfiles = () => API.get("/profiles");
export const fetchProfilesByUser = (searchQuery) =>
  API.get(`/profiles?searchQuery=${searchQuery.search}`);
// console.log("fetchProfilesByUser called in client")
// console.log(searchQuery.search)

export const createProfile = (newProfile) => API.post("/profiles", newProfile);
export const updateProfile = (id, updatedProfile) =>
  API.post(`/profiles/${id}`, updatedProfile);
export const deleteProfile = (id) => API.post(`/profiles/delete/${id}`);

export const createFuturePriceList = (futurePriceList) =>
  API.post("/items/future-prices", futurePriceList);
export const fetchFuturePriceList = () => API.get("/items/future-prices");
export const updateFuturePrice = (id, priceData) =>
  API.post(`/items/future-prices/update/${id}`, priceData);
export const deleteFuturePrice = (id) => API.post(`/items/future-prices/delete/${id}`);

export const fetchItem = (id) => API.get(`/items/${id}`);
export const fetchItems = () => API.get("/items");
export const addItem = (item) => API.post("/items", item);
export const addItems = (item) => API.post("/items/file", item);
export const updateItem = (id, updatedItem) =>
  API.post(`/items/update/${id}`, updatedItem);
export const toggleItemStatus = (id) => API.post(`/items/toggle/${id}`);

export const deleteItem = (id) => API.post(`/items/delete/${id}`);
export const deleteItemsByCategoryId = (id) => API.post(`/items/deleteByCategoryId/${id}`);
export const fetchItemsByUser = (searchQuery) =>
  API.get(`/items/user?searchQuery=${searchQuery.searcategoriesch}`);
export const updateItems = (items) => API.post("/items/update", items);

export const fetchUnits=()=>API.get(`/units`)
export const addUnit=(unit)=>API.post(`/units`, unit)
export const addUnits=(unit)=>API.post(`/units/createAll`, unit)
export const getUnitById=(id)=>API.get(`/units/${id}`)
export const mapUnit = (mappingData) => API.post("/units/map", mappingData);

export const deleteBasicUnit = (id) => API.post(`/units/delete-basic/${id}`);
export const deleteMappedUnit = (id) => API.post(`/units/delete-mapped/${id}`);
export const updateBasicUnit = (id, unit) => API.post(`/units/update-basic/${id}`, unit);
export const updateMappedUnit = (id, unit) => API.post(`/units/update-mapped/${id}`, unit);


// Unit API Calls
export const fetchUnitMappings = () => API.get("/units/mappings");
export const createUnit = (newUnit) => API.post("/units", newUnit);
export const convertUnits = (conversionData) => API.post("/units/convert", conversionData);
export const updateUnit = (id, updatedUnit) => API.post(`/units/update/${id}`, updatedUnit);
export const deleteUnit = (id) => API.post(`/units/delete/${id}`);
export const deleteUnitMapping = (id) => API.post(`/units/delete-mapping/${id}`);
export const updateUnitMapping = (id, mappingData) => axios.post(`/unit-mappings/update/${id}`, mappingData);



export const fetchCategory = (id) => API.get(`/categories/${id}`);
export const addCategory = (stock) => API.post("/categories", stock);



export const updateCategory = (id, updatedCategory) =>
  API.post(`/categories/${id}`, updatedCategory);
export const toggleCategoryStatus = (id) => API.post(`/categories/toggle/${id}`);
export const deleteCategory = (id) => API.post(`/categories/delete/${id}`);
export const fetchCategoriesByUser = (searchQuery) =>
  API.get(`/categories/user?searchQuery=${searchQuery.search}`);
export const fetchCategories = () => API.get("/categories");

export const fetchStock = (id) => API.get(`/stocks/${id}`);
export const addStock = (stock) => API.post("/stocks", stock);
export const updateStock = (id, updatedStock) =>
  API.post(`/stocks/${id}`, updatedStock);
export const deleteStock = (id) => API.post(`/stocks/delete/${id}`);
export const deleteStockById = (id, type) => API.post(`/stocks/${type}/${id}`);
export const fetchStocksByUser = (searchQuery) =>
  API.get(`/stocks/user?searchQuery=${searchQuery.search}`);
export const fetchStocks = () => API.get("/stocks");

export const getCurrentStockQuantity=(itemId)=>API.get(`/stocks/quantity/${itemId}`);




export const fetchStockAdjustment = (id) => API.get(`/stockAdjustments/${id}`);
export const addStockAdjustment = (stockAdjustment) =>
  API.post("/stockAdjustments", stockAdjustment);
export const updateStockAdjustment = (id, updatedStockAdjustment) =>
  API.post(`/stockAdjustments/${id}`, updatedStockAdjustment);
export const deleteStockAdjustment = (id) =>
  API.post(`/stockAdjustments/delete/${id}`);
export const fetchStockAdjustmentsByUser = (searchQuery) =>
  API.get(`/stockAdjustments?searchQuery=${searchQuery.search}`);
export const fetchStockAdjustments = () => API.get("/stockAdjustments");

export const fetchStaff = (id) => API.get(`/staff/${id}`);
export const fetchStaffByPage = (page) => API.get(`/staff?page=${page}`);
export const addStaff = (client) => API.post("/staff", client);
export const updateStaff = (id, updatedStaff) =>
  API.post(`/staff/${id}`, updatedStaff);
export const deleteStaff = (id) => API.post(`/staff/delete/${id}`);
export const fetchStaffByUser = (searchQuery) =>
  API.get(`/staff/user?searchQuery=${searchQuery.search}`);
export const fetchAllStaff = () => API.get("/staff");

// New User Type API Calls
// User Type API Calls
export const fetchUserTypes = () => API.get("/users/userTypes");
export const createUserType = (userTypeData) => {
  console.log("API createUserType called with URL:", "/users/userTypes", "data:", userTypeData);
  return API.post("/users/userTypes", userTypeData);
};
export const updateUserType = (name, userTypeData) => {
  console.log("Updating user type with URL:", `/users/userTypes/update/${name}`); 
  return API.post(`/users/userTypes/update/${name}`, userTypeData);
};
export const deleteUserType = (name) => {
  console.log("Deleting user type with URL:", `/users/userTypes/delete/${name}`); 
  return API.post(`/users/userTypes/delete/${name}`);
};
export const getUserPermissions = () => API.get('/users/permissions');

// Subscription Management APIs
export const getSubscription = () => API.get("/subscription");
export const updateSubscription = (subscriptionData) =>
  API.post("/subscription/update", subscriptionData);


export const uploadLogo = (logoBase64) => {
  return API.post("/company-logo/upload", { logoBase64 });
};

export const getLogo = () => {
  return API.get("/company-logo/logo");
};

// Employee Master APIs (GET and POST only)
export const fetchEmployees = () => API.get("/employees");
export const fetchEmployee = (id) => API.get(`/employees/${id}`);
export const addEmployee = (employee) => API.post("/employees", employee);
export const updateEmployee = (id, employee) =>
  API.post(`/employees/${id}`, employee);

// Shift APIs (session lifecycle per employee)
export const getMyActiveShift = () => API.get("/shifts/my-active");
export const getActiveShifts = () => API.get("/shifts/active");
export const getShiftLogs = (params) =>
  API.get("/shifts/logs", { params: params || {} });
export const getLastShiftByEmployee = () => API.get("/shifts/last-by-employee");
export const clearShiftLogs = (startDate, endDate) =>
  API.post("/shifts/logs/clear", { startDate, endDate });
export const startShift = (payload) =>
  API.post("/shifts/start", typeof payload === "object" ? payload : { userName: payload });
export const endShift = () => API.post("/shifts/end");

// Order Sessions (Hold Bill) APIs - GET and POST only
export const createOrderSession = (data) =>
  API.post("/order-sessions", data);
export const getOrderSessions = (params) =>
  API.get("/order-sessions", { params: params || {} });
export const getOrderSession = (id) =>
  API.get(`/order-sessions/${id}`);
export const addItemToOrderSession = (id, item) =>
  API.post(`/order-sessions/${id}/add-item`, item);
export const removeItemFromOrderSession = (id, itemIdOrPayload) =>
  API.post(
    `/order-sessions/${id}/remove-item`,
    typeof itemIdOrPayload === "object" && itemIdOrPayload !== null
      ? itemIdOrPayload
      : { itemId: itemIdOrPayload }
  );
export const updateItemInOrderSession = (id, itemIdOrPayload, qtyOrUndefined) =>
  API.post(
    `/order-sessions/${id}/update-item`,
    typeof itemIdOrPayload === "object" && itemIdOrPayload !== null
      ? itemIdOrPayload
      : { itemId: itemIdOrPayload, qty: qtyOrUndefined }
  );
export const checkoutOrderSession = (id, paymentData) =>
  API.post(`/order-sessions/${id}/checkout`, paymentData);
export const printKot = (id, itemIds) =>
  API.post(`/order-sessions/${id}/print-kot`, { itemIds });